type BaseError = "ServerError" | "NetworkError";

export type UserRemoteDataSourceError =
  | BaseError
  | "PhoneAlreadyUsedError"
  | "EmailAlreadyUsedError"
  | "WrongPasswordError"
  | "WrongVerificationCodeError";

export const UserRemoteDataSourceError = {
  serverError: () => new Error("ServerError"),
  networkError: () => new Error("NetworkError"),
  phoneAlreadyUsedError: () => new Error("PhoneAlreadyUsedError"),
  emailAlreadyUsedError: () => new Error("EmailAlreadyUsedError"),
  wrongPasswordError: () => new Error("WrongPasswordError"),
  wrongVerificationCodeError: () => new Error("WrongVerificationCodeError"),
};

export type AddressRemoteDataSourceError = BaseError;

export const AddressRemoteDataSourceError = {
  serverError: () => new Error("ServerError"),
  networkError: () => new Error("NetworkError"),
};

export type ProductsRemoteDataSourceError =
  | BaseError
  | "ProductNotFoundError"
  | "CategoryNotFoundError";

export const ProductsRemoteDataSourceError = {
  serverError: () => new Error("ServerError"),
  networkError: () => new Error("NetworkError"),
  productNotFoundError: () => new Error("ProductNotFoundError"),
  categoryNotFoundError: () => new Error("CategoryNotFoundError"),
};

export type HomeRemoteDataSourceError = BaseError;
export const HomeRemoteDataSourceError = {
  serverError: () => new Error("ServerError"),
  networkError: () => new Error("NetworkError"),
};
